import React from "react";

interface InsightIconProps {
  children: React.ReactNode;
  className?: string;
}

export const InsightIcon: React.FC<InsightIconProps> = ({
  children,
  className,
}) => {
  return (
    <span
      className={`insight-reference ${className || ""}`}
      style={{
        cursor: "pointer",
        color: "#1976d2",
        backgroundColor: "#e3f2fd",

        // backgroundColor: "#1976d2",
        // color: "#e3f2fd",

        padding: "2px 6px",
        borderRadius: "50%",
        fontSize: "0.7rem",
        fontWeight: "bold",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: "16px",
        height: "16px",
        fontStyle: "italic",
      }}
    >
      {children}
    </span>
  );
};
